import { Directive, Self, OnInit } from '@angular/core';

import { MapService } from '../../map';
import { ShareMapComponent } from './share-map.component';


@Directive({
  selector: '[igoShareMapBinding]'
})
export class ShareMapBindingDirective implements OnInit {

  private component: ShareMapComponent;

  constructor(@Self() component: ShareMapComponent,
              private mapService: MapService) {
    this.component = component;
  }

  ngOnInit() {
    this.component.map = this.mapService.getMap();
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/share-map/share-map/share-map-binding.directive.ts